// extracted by mini-css-extract-plugin
export var container = "_ut-0";
export var table = "_ut-2";
export var tableWrapper = "_ut-1";